import {
  SlInput
} from "./chunk.UA4HYG7D.js";

// src/components/input/input.ts
var input_default = SlInput;
SlInput.define("sl-input");

export {
  input_default
};
